import {FC, useState, useEffect, Fragment} from 'react'

import {Col, Form, Modal, Row} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'

import './style.css'
import ReactQuill from 'react-quill'

import Button from 'react-bootstrap/Button'
import AlertModal from './AlertModal'
import {clearLocalStorageExcept} from 'thesis-and-dissertations/helpers/helper'
const api = new Api()

type Props = {
  showFormModal: boolean
  handleCloseFormModal: any
  presention: any
  reloadData: any
}
const FormPresentionContent: FC<Props> = ({
  showFormModal,
  handleCloseFormModal,
  presention,
  reloadData,
}) => {
  const navigate = useNavigate()

  const [showAlertModal, setShowAlertModal] = useState(false)

  const [showModal, setShowModal] = useState(false)
  const [errors, setErrors] = useState<any>({})
  const [isLoading, setIsLoading] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [loading, setLoading] = useState<any>(false)

  useEffect(() => {
    setShowModal(showFormModal)
    setFormValue({...formValue, ...presention})
  }, [showFormModal])

  const toggle = () => {
    setShowModal(!showModal)
    handleCloseFormModal()

    setFormValue({})
  }

  const handleInput = (name: any, value: any) => {
    setFormValue({...formValue, [name]: value})
    setErrors({})
  }

  const saveData = () => {
    setLoading(true)
    api
      .changePresention(formValue)
      .then((response: any) => {
        const {data} = response.data
        setLoading(false)
        toast.success(data?.message ?? data?.meta?.message ?? 'Berhasil simpan data')
        toggle()
        reloadData(true)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        setErrors(data?.meta?.error ?? data?.errors)
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  return (
    <>
      <Modal show={showModal} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Form Kehadiran</Modal.Title>
        </Modal.Header>
        <Form>
          <Modal.Body>
            <div>
              <p className='mb-2'>Kehadiran</p>
              <select
                value={formValue?.is_hadir}
                onChange={(e: any) => handleInput('is_hadir', e.target?.value)}
                className={`form-control ${errors?.is_hadir ? 'border-danger' : ''}`}
              >
                <option value=''>--Pilih Kehadiran--</option>
                <option value='1'>Hadir</option>
                <option value='0'>Tidak Hadir</option>
              </select>

              {errors?.is_hadir && <p className='text-danger mt-3'>{errors?.is_hadir}</p>}
            </div>

            <div className='mt-5'>
              <p className='mb-2'>Catatan</p>
              <textarea
                value={formValue?.catatan}
                onChange={(e: any) => handleInput('catatan', e.target?.value)}
                className={`form-control ${errors?.catatan ? 'border-danger' : ''}`}
              ></textarea>
              {errors?.catatan && <p className='text-danger mt-3'>{errors?.catatan}</p>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type='button' className='btn btn-sm btn-secondary' onClick={toggle}>
              Batalkan
            </button>
            <button type='button' className='btn btn-sm btn-primary' onClick={saveData}>
              {isLoading ? 'Loading' : 'Simpan'}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

const FormPresention: FC<Props> = ({
  showFormModal,
  handleCloseFormModal,
  presention,
  reloadData,
}) => {
  return (
    <FormPresentionContent
      showFormModal={showFormModal}
      handleCloseFormModal={handleCloseFormModal}
      presention={presention}
      reloadData={reloadData}
    />
  )
}

export default FormPresention
